'use client'

import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { IconCaretLeft } from '@redteclab/icons'

import { Heading, Link } from 'base-ui'

import { useGlobalConfigContext } from '../../../../global-config'
import { urlResolverGetBrandsIndexPage } from '../../../../url-handling'

import { StoryblokBrandBreadcrumbs } from './StoryblokBrandBreadcrumbs'

export const StoryblokBrandHeader: FC<{ title: string | undefined }> = ({
  title,
}) => {
  const publicGlobalConfig = useGlobalConfigContext()
  const intl = useIntl()

  return (
    <>
      {title ? <StoryblokBrandBreadcrumbs currentBrand={title} /> : null}
      <section className="container flex items-center">
        <Link
          aria-label={intl.formatMessage({
            id: 'general.link.label.backToBrandIndex',
          })}
          className="shrink-0"
          href={urlResolverGetBrandsIndexPage(publicGlobalConfig)}
        >
          <IconCaretLeft className="size-11" />
        </Link>
        {title ? (
          <Heading level={1} size="2xl">
            {title}
          </Heading>
        ) : null}
      </section>
    </>
  )
}
